import * as React from 'react';
import { LocaleLink } from '../locale-helpers';
import { useEffect } from 'react';
import { ENVIRONMENT } from '../../constants';

const Logo = () => {
  let logoPath: any;
  try {
    logoPath = require('../../../../logo.png');
  } catch (error) {
    logoPath = require('../../../../defaultlogo.png');
  }

  function updateFavicon() {
    const favElement: HTMLLinkElement = document.getElementById(
      'favicon'
    ) as HTMLLinkElement;
    favElement.href = logoPath;
  }

  function updateTitle() {
    document.title = ENVIRONMENT.title;
  }

  useEffect(() => {
    updateFavicon();
    updateTitle();
  }, []);

  return (
    <LocaleLink className="main-logo" to="">
      <img
        className="main-mozilla-logo"
        src={logoPath}
        alt="Mozilla Common Voice"
      />
    </LocaleLink>
  );
};

export default Logo;
